import BaseViewModel, { Required } from '@/infrastructure/BaseViewModel';

export default class User extends BaseViewModel {
    public Id: number = 0;
    public CustomerId: number | null = 0;
    @Required('First name cannot be null.')
    public FirstName: string = '';
    @Required('Last name cannot be null.')
    public LastName: string = '';
    public Email: string = '';
    @Required('User name cannot be null.')
    public UserName: string = '';
    @Required('Password cannot be null.')
    public Password: string = '';
    public IsAdmin: boolean = false;
    public Active: boolean = false;
    public Token: string = '';
    public Deleted: boolean = false;
    public DateCreated: Date = new Date();
    public DateUpdated: Date = new Date();
}
